class MapManager {

    constructor(props, callback){
        // ID for map div  
        this.mapid = props.mapid || 'map';
        this.default  = {
            lat : props.lat,
            lng : props.lng
        };
        this.zoom = +props.zoom || 12;
        this.infowindow = false;
        this.latlng = false;
        this.mapOptions = {};
        this.map = false;
        this.geocoder = false;
        this.bounds = false;
        // all of the known locations are passed here
        this.locations = [],
        // used for looping
        this.nextAddress = 0;
        // keeps makers that are created in here, useful for closest marker finding
        this.markers = [];
        this.delay = 10;
        this.closestDistance = false;
        this.closestMarker = false;
        this.mapdata = props.mapdata;
        this.callback = callback;
        this.listing = [];
        this.category = '';
        this.pins = props.pins;    
        
        this.current = {
            lat : false,
            lng : false};
        
        this.init();
        
    }

    checkSet(val) {
        if(val !== undefined && val !== null && val !== ''){
            return true;
        }
        return false;
    }

    createContentString (values) {
        var str = '';    
        
        if(this.checkSet(values.email)){
            var email = '<svg version="1.1" width="14" height="14" viewBox="0 0 14 14"><path d="M13 11.75v-6c-0.164 0.187-0.344 0.359-0.539 0.516-1.117 0.859-2.242 1.734-3.328 2.641-0.586 0.492-1.313 1.094-2.125 1.094h-0.016c-0.813 0-1.539-0.602-2.125-1.094-1.086-0.906-2.211-1.781-3.328-2.641-0.195-0.156-0.375-0.328-0.539-0.516v6c0 0.133 0.117 0.25 0.25 0.25h11.5c0.133 0 0.25-0.117 0.25-0.25zM13 3.539c0-0.195 0.047-0.539-0.25-0.539h-11.5c-0.133 0-0.25 0.117-0.25 0.25 0 0.891 0.445 1.664 1.148 2.219 1.047 0.82 2.094 1.648 3.133 2.477 0.414 0.336 1.164 1.055 1.711 1.055h0.016c0.547 0 1.297-0.719 1.711-1.055 1.039-0.828 2.086-1.656 3.133-2.477 0.508-0.398 1.148-1.266 1.148-1.93zM14 3.25v8.5c0 0.688-0.563 1.25-1.25 1.25h-11.5c-0.688 0-1.25-0.563-1.25-1.25v-8.5c0-0.688 0.563-1.25 1.25-1.25h11.5c0.688 0 1.25 0.563 1.25 1.25z"></path></svg>';
            str +=  "<br><a href='mailto:"+values.email+"' data-category='clinic_info' data-action='email' data-label='"+values.title+"'>"+email+values.email+"</a>";
        }

        if(this.checkSet(values.tel)){
            var tel = '<svg version="1.1" width="11" height="14" viewBox="0 0 11 14"><path d="M11 9.687c0 0.281-0.125 0.828-0.242 1.086-0.164 0.383-0.602 0.633-0.953 0.828-0.461 0.25-0.93 0.398-1.453 0.398-0.727 0-1.383-0.297-2.047-0.539-0.477-0.172-0.937-0.383-1.367-0.648-1.328-0.82-2.93-2.422-3.75-3.75-0.266-0.43-0.477-0.891-0.648-1.367-0.242-0.664-0.539-1.32-0.539-2.047 0-0.523 0.148-0.992 0.398-1.453 0.195-0.352 0.445-0.789 0.828-0.953 0.258-0.117 0.805-0.242 1.086-0.242 0.055 0 0.109 0 0.164 0.023 0.164 0.055 0.336 0.438 0.414 0.594 0.25 0.445 0.492 0.898 0.75 1.336 0.125 0.203 0.359 0.453 0.359 0.695 0 0.477-1.414 1.172-1.414 1.594 0 0.211 0.195 0.484 0.305 0.672 0.789 1.422 1.773 2.406 3.195 3.195 0.187 0.109 0.461 0.305 0.672 0.305 0.422 0 1.117-1.414 1.594-1.414 0.242 0 0.492 0.234 0.695 0.359 0.438 0.258 0.891 0.5 1.336 0.75 0.156 0.078 0.539 0.25 0.594 0.414 0.023 0.055 0.023 0.109 0.023 0.164z"></path></svg>';
            str +=  "<br><a href='tel:"+values.tel+"' data-category='clinic_info' data-action='phone' data-label='"+values.title+"'>"+tel+values.tel+"</a>";
        }
        
        if(this.checkSet(values.whatsapp)){
            var whatsapp = '<svg version="1.1" width="12" height="14" viewBox="0 0 12 14"><path d="M7.695 7.609c0.133 0 1.406 0.664 1.461 0.758 0.016 0.039 0.016 0.086 0.016 0.117 0 0.195-0.062 0.414-0.133 0.594-0.18 0.438-0.906 0.719-1.352 0.719-0.375 0-1.148-0.328-1.484-0.484-1.117-0.508-1.812-1.375-2.484-2.367-0.297-0.438-0.563-0.977-0.555-1.516v-0.062c0.016-0.516 0.203-0.883 0.578-1.234 0.117-0.109 0.242-0.172 0.406-0.172 0.094 0 0.187 0.023 0.289 0.023 0.211 0 0.25 0.062 0.328 0.266 0.055 0.133 0.453 1.195 0.453 1.273 0 0.297-0.539 0.633-0.539 0.813 0 0.039 0.016 0.078 0.039 0.117 0.172 0.367 0.5 0.789 0.797 1.070 0.359 0.344 0.742 0.57 1.18 0.789 0.055 0.031 0.109 0.055 0.172 0.055 0.234 0 0.625-0.758 0.828-0.758zM6.109 11.75c2.703 0 4.906-2.203 4.906-4.906s-2.203-4.906-4.906-4.906-4.906 2.203-4.906 4.906c0 1.031 0.328 2.039 0.937 2.875l-0.617 1.82 1.891-0.602c0.797 0.523 1.742 0.813 2.695 0.813zM6.109 0.953c3.25 0 5.891 2.641 5.891 5.891s-2.641 5.891-5.891 5.891c-0.992 0-1.977-0.25-2.852-0.734l-3.258 1.047 1.062-3.164c-0.555-0.914-0.844-1.969-0.844-3.039 0-3.25 2.641-5.891 5.891-5.891z"></path></svg>';
            str +=  "<br><a target='_blank' href='"+values.whatsapp+"' data-category='clinic_info' data-action='whatsapp' data-label='"+values.title+"'>"+whatsapp+"WhatsApp</a>";
        }


        if(this.checkSet(values.uri)){       
            str +=  "<br><br><a href='"+values.uri+"' data-category='map' data-action='internal_link' data-label='"+values.uri+"'>"+window.mapinfo.translate.more_info+"</a>";
        }



        return "<div class='info-window'><h2>"+values.title+"</h2><address>" +  this.splitAddress(values.address) + "</address>" + str +"</div>";
        
    }
    
    createMarker (values) {
        
        var contentString = this.createContentString(values);
        
        var mapOptions = {
            position: new google.maps.LatLng(values.lat,values.lng),
            category: values.services,
            map: this.map
        };

        if(this.checkSet(values.type)){
            var found = this.pins.find(obj => { return obj.slug == values.type });
            if(found != undefined) {
                mapOptions['icon']=found.url;
            }

        }

        var marker = new google.maps.Marker(mapOptions);
              
        // add click event listener on pins
        google.maps.event.addListener(marker, 'click', ()=> {
            if (this.infowindow) {
                this.infowindow.close();
            } 
            this.infowindow.setContent(contentString); 
            this.infowindow.open(this.map,marker);
        });    
    
        this.markers.push(marker);
            
        this.bounds.extend(marker.position);     
   }
  
    // gets lat lng by postcode of comma separated address
    getByLatLng (postcode) {    
      this.geocoder.geocode({
          'address': postcode
      },  (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
                this.current.lat = results[0].geometry.location.lat();
                this.current.lng = results[0].geometry.location.lng();
                this.findClosestMarker();
                this.reorderListing();
          }
          });
      }
      // turns commas into br
      splitAddress (address){
          return address.split(",").join("<br />");
      }
      // loops known locations who have a lat lng
      loopKnownMarkers(){
         
         for( var i = 0; i < this.mapdata.length; i++){                 
                this.createMarker(
                    this.mapdata[i]                
                );
        }
        
        this.map.fitBounds(this.bounds);
        this.tryGeoSync();
      }
      // convert to RAD (radius)
      rad (x) {
          return x*Math.PI/180;
      }
      // Haverstine equasion to working out closest match
      findClosestMarker () {
          var lat = this.current.lat;
          var lng = this.current.lng;
          if(this.infowindow)this.infowindow.close();
          var R = 6371; // radius of earth in km
          var distances = [];
          var closest = -1;
          
          for( var i=0;i<this.markers.length; i++ ) {
              if(this.markers[i].visible === false){
                  continue;
              }             
              var dLat  = this.rad(this.markers[i].position.lat() - lat);
              var dLong = this.rad(this.markers[i].position.lng() - lng);
              var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                  Math.cos(this.rad(lat)) * Math.cos(this.rad(lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);
              var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
              var d = R * c;
              distances[i] = d;
              
              if ( closest == -1 || d < distances[closest] ) {
                  closest = i;
              }
          }
          
          this.centerOnClosest(closest, lat, lng);
      }

      setBasicListing(){
        this.listing = this.mapdata.map( (elm,index) => {
            return {title: elm.title, 
                    address: elm.address,
                    uri : elm.uri,
                    category : elm.services,
                    index : index
                };
        });        
      }

      reorderListing() {
        var lat = this.current.lat;
        var lng = this.current.lng;
        var R = 6371;
        
        this.listing = this.mapdata.map((elm, index) => {
            var dLat  = this.rad(elm.lat - lat);
            var dLong = this.rad(elm.lng - lng);            
            var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(this.rad(lat)) * Math.cos(this.rad(lat)) * Math.sin(dLong/2) * Math.sin(dLong/2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            var d = R * c; 
            return {title: elm.title, 
                    address: elm.address,
                    uri : elm.uri,
                    category : elm.services, 
                    distance: d,
                    index: index,
                    km: this.convertToKM(d),
                    miles: this.convertToMiles(d)  };
        });

        if(this.category.length !== 0) {
            this.listing = this.listing.filter(elm => {
                return this.checker(elm.category, this.category) ;
            });
        }

        this.listing.sort((a, b) => (a.distance > b.distance) ? 1 : -1);
        this.callback( this.listing );

      }

      round (number, decimalPlaces){
        const factorOfTen = Math.pow(10, decimalPlaces)
        return Math.round(number * factorOfTen) / factorOfTen
      }

      convertToKM(value) {
        if(value < 0) {
            return Math.round(value*100) + "m";
        } else if (Math.round(value) < 11  ) 
            return this.round(value,2) + "km";
        else {
            return Math.round(value) + "km";
        }
      }
      convertToMiles(value) {
        value =  (value /1.609344 ); 
        if (Math.round(value) < 11  ) 
            return this.round(value,2) + " miles";
        else {
            return Math.round(value) + " miles";
        }
      }
      centerOnClosest (i, lat, lng){          
          this.map.setCenter(
                  new google.maps.LatLng(
                      this.markers[i].position.lat(),
                      this.markers[i].position.lng()
                      )
                  );         
          google.maps.event.trigger(this.markers[i], 'click');
          this.map.setZoom(this.zoom);          
          this.infowindow.setContent(this.infowindow.getContent());          
      }
      
      tryGeoSync() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                    this.current.lat = position.coords.latitude;
                    this.current.lng = position.coords.longitude;
                    this.findClosestMarker();
                    this.reorderListing();
                }
            );
            
        }
    }
    setCategory(category) {   
        
        this.category = category;

    }

    setVisibility() {
        for (var i = 0; i < this.markers.length; i++) {
            if (this.category.length === 0 || 
                this.markers[i].category == this.category || 
                this.checker(this.markers[i].category, this.category) ) {
                    this.markers[i].setVisible(true);
            }
            else {
                this.markers[i].setVisible(false);
            }
        }

        if (this.infowindow) {
            this.infowindow.close();
        }

        this.setBasicListing();
        if(this.category.length !== 0) {          
            this.listing = this.listing.filter(elm => {          
                return this.checker(elm.category, this.category) ;
            });          
        }        
    }

    openMapPin(index) {
        this.map.setCenter(this.markers[index].getPosition())
        var contentString = this.createContentString(this.mapdata[index]);
        this.map.setZoom(12);
        if (this.infowindow) {
            this.infowindow.close();
        }
        this.infowindow.setContent(contentString); 
        this.infowindow.open(this.map,this.markers[index]);
    }

    filter() {        
        this.callback( this.listing );
    }

    checker (arr, target) {
        return target.every(v => arr.includes(v))
    } ;

      init (){
        
        // if the div with correct ID does not exist do nothing
        if(document.getElementById(this.mapid) !== null) {      
            
            this.infowindow = new google.maps.InfoWindow();
            
            this.geocoder = new google.maps.Geocoder(),
            this.bounds = new google.maps.LatLngBounds(),
            this.latlng = new google.maps.LatLng(this.default.lat, this.default.lng);
            this.mapOptions ={
                zoom: this.zoom,
                center: this.latlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
                        
            
            this.map = new google.maps.Map(document.getElementById(this.mapid), this.mapOptions);
            
           this.loopKnownMarkers();

           this.setBasicListing();
            
        }
      }
}
  
export default MapManager;